import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionGetArchiveClausePathParameters } from 'api/actions/revision-get-archive-clause/revision-get-archive-clause-path-parameters';
import { RevisionGetArchiveClauseResponse } from 'api/actions/revision-get-archive-clause/revision-get-archive-clause-response';

type RevisionGetArchiveClauseQueryParameters = Record<string, any>;

/**
 * The path of the RevisionGetArchiveClause action.
 */
export const revisionGetArchiveClauseActionPath = new SweetPath<keyof RevisionGetArchiveClausePathParameters>(
  '/api/revision/get-archive-clause/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionGetArchiveClause actions.
 */
export default function createRevisionGetArchiveClauseAction(axios: AxiosInstance) {
  return function revisionGetArchiveClauseAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionGetArchiveClausePathParameters;
    query?: RevisionGetArchiveClauseQueryParameters;
  }) {
    const path = revisionGetArchiveClauseActionPath.insert(parameters);

    return axios.request<RevisionGetArchiveClauseResponse, RevisionGetArchiveClauseResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
